<template>
  <img :src="icon" alt="" :class="classesIcon" />
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./IconStyle.module.scss";

export default defineComponent({
  name: "IconBase",
  props: {
    icon: {
      type: String,
      default: ""
    },
    tone: {
      type: String as PropType<IconTone>,
      default: "default"
    },
    size: {
      type: String as PropType<Size>,
      default: "M"
    }
  },
  data() {
    return {
      style
    };
  },
  computed: {
    classesIcon() {
      return [
        this.style[`toneLevel-${this.tone}`],
        this.style[`size${this.size}`]
      ];
    }
  }
});
</script>
